var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"type":"dark"}},[_c('a',{attrs:{"href":""},on:{"click":function($event){return _vm.$router.push('/')}}},[_c('img',{attrs:{"src":require("../assets/Apop_Logo_xsm.png"),"alt":"small logo"}})]),_c('ApopUserMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }